import Component from "./ButtonsCircleView";
import ButtonCircle from "./components/ButtonCircle/ButtonsCircleViewButtonCircle";

interface IButtonsCircleViewExtensions {
    ButtonCircle: typeof ButtonCircle;
}

export const ButtonsCircleView: typeof Component &
    IButtonsCircleViewExtensions = Object.assign(Component, {
    ButtonCircle,
});

export * from "./ButtonsCircleView";
